import * as React from 'react';
import { useContext } from 'react';
import { Redirect } from 'react-router-dom';
import SearchView from 'containers/search';
import { PwrDistroMediaFieldsets } from 'containers/search/SearchForm';
import { ClientContext } from 'containers/client/ClientProvider';
import { getIsPwrDistroClient } from 'components/ModerationCard/ClientModerationCard/utils';

export function MediaSearch(props) {
  const clientProps = useContext(ClientContext);

  if (clientProps && !getIsPwrDistroClient(clientProps.clientId, clientProps)) {
    const { location } = props;
    const newPathname = location.pathname.replace(
      '/media-search',
      '/images-and-video'
    );
    return <Redirect to={{ pathname: newPathname, search: location.search }} />;
  }

  return (
    <SearchView
      label="Images & Video"
      primaryFieldsets={PwrDistroMediaFieldsets.primaryFieldsets}
      extraFieldsets={PwrDistroMediaFieldsets.extraFieldsets}
      {...props}
    />
  );
}



// WEBPACK FOOTER //
// ./src/containers/search/PwrDistribution/MediaSearch.js